import React, { useContext, useMemo } from 'react';
import { ChildContext } from '../../context/ChildContext';
import { currencies } from '../basic/currencies';
import './AllowanceInfo.css';

function AllowanceInfo() {
    const { dashboardData } = useContext(ChildContext);

    const getCurrencySymbol = (currencyCode) => {
        const currency = currencies.find(c => c.code === currencyCode);
        return currency ? currency.symbol : '$'; // Default to '$' if not found
    };

    const calculateDaysUntilNextDeposit = useMemo(() => {
        if (!dashboardData) return 0;

        const today = new Date();
        const todayDayOfWeek = today.getDay();
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const distributionDayIndex = days.indexOf(dashboardData.dayOfDistribution);

        let daysUntilNextDeposit = distributionDayIndex - todayDayOfWeek;
        if (daysUntilNextDeposit <= 0) {
            daysUntilNextDeposit += 7; // Ensure it's always a future event
        }

        return daysUntilNextDeposit;
    }, [dashboardData]);

    if (!dashboardData) {
        return <div className="allowance-info">Loading allowance information...</div>;
    }

    const currencySymbol = getCurrencySymbol(dashboardData.currencyCode);

    return (
        <div className="allowance-info">
            <div className="allowance-info__frame">
                <p className="allowance-info__label">Weekly Allowance</p>
                <p className="allowance-info__value">{currencySymbol}{dashboardData.weeklyAllowance}</p>
            </div>
            <div className="allowance-info__frame">
                <p className="allowance-info__label">Days to Next Deposit</p>
                <p className="allowance-info__value">{calculateDaysUntilNextDeposit}</p>
            </div>
            <div className="allowance-info__frame">
                <p className="allowance-info__label">Payday</p>
                <p className="allowance-info__value">{dashboardData.dayOfDistribution}</p>
            </div>
            <div className="allowance-info__frame">
                <p className="allowance-info__label">Total Balance</p>
                <p className="allowance-info__value">{currencySymbol}{dashboardData.totalAccountsBalance.toLocaleString('en-US')}</p>
            </div>
        </div>
    );
}

export default AllowanceInfo;